import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CreditCardIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2 9.55556H22M6.44444 15.1111H7.55556M12 15.1111H13.1111M5.33333 19.5556H18.6667C19.5507 19.5556 20.3986 19.2044 21.0237 18.5792C21.6488 17.9541 22 17.1063 22 16.2222V7.33333C22 6.44928 21.6488 5.60143 21.0237 4.97631C20.3986 4.35119 19.5507 4 18.6667 4H5.33333C4.44928 4 3.60143 4.35119 2.97631 4.97631C2.35119 5.60143 2 6.44928 2 7.33333V16.2222C2 17.1063 2.35119 17.9541 2.97631 18.5792C3.60143 19.2044 4.44928 19.5556 5.33333 19.5556Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

CreditCardIcon.displayName = 'CreditCardIcon';
